import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RegistrationList } from 'src/app/kuba/Registration/models/registration-list';
import { Observable } from 'rxjs';

import { RegistrationServices } from '../services/registration.service';


@Injectable()
export class RegistrationListResolver {
  constructor(private backend: RegistrationServices) { }
  resolve(route: ActivatedRouteSnapshot): Observable<RegistrationList[]> {
    return this.backend.getAllByEach(+route.params['Id'], route.parent.parent.data['parent']);
  }
}

@Injectable()
export class RegistrationEditResolver {
  constructor(private backend: RegistrationServices) { }
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getRegisterById(+route.params['rid']);
  }
}

@Injectable()
export class TypeOfRegistrationListResolver {
  constructor(private backend: RegistrationServices) { }
  resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
    return this.backend.getAllByRegType(+route.parent.parent.params['id'], route.parent.parent.data['parent']);
  }
}
